module.exports = __webpack_public_path__ + "img/logo.10ddf761.png";